/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AbteilungDto } from '../../models/abteilung-dto';

export interface GetAbteilungen$Json$Params {
}

export function getAbteilungen$Json(http: HttpClient, rootUrl: string, params?: GetAbteilungen$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AbteilungDto>>> {
  const rb = new RequestBuilder(rootUrl, getAbteilungen$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AbteilungDto>>;
    })
  );
}

getAbteilungen$Json.PATH = '/v1/abteilungen';
